import { COUNTRIES, EU_COUNTRIES } from '@/constants/countries.js'

export function getCountryName(countryCode) {
  if (countryCode) {
    const country = COUNTRIES.find((country) => country.value === countryCode)
    if (country) {
      return country.text
    }
    return ''
  }

  return ''
}

export function isEuCountry(countryCode) {
  return EU_COUNTRIES.includes(countryCode?.toUpperCase())
}
